
import { useLocation } from 'react-router-dom';
import { Chat } from '@/components/Chat';
import { BackButton } from '@/components/ui/back-button';

const ChatWithClaude = () => {
  const location = useLocation();
  const { prompt } = location.state || { prompt: '' };

  return (
    <main className="min-h-screen bg-white py-12">
      <div className="max-w-4xl mx-auto px-4">
        <BackButton />
        <Chat initialPrompt={prompt} />
      </div>
    </main>
  );
};

export default ChatWithClaude;
